import { render, staticRenderFns } from "./bienvenue.vue?vue&type=template&id=6d5f5512"
import script from "./bienvenue.js?vue&type=script&lang=js&external"
export * from "./bienvenue.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports